<ng-container *ngIf="currentStep === 2">
  <div class="row justify-content-center">

    <div class="col-md-11 col-lg-10 col-xl-8 step">
      <section class="row justify-content-between align-items-center taxonomies-creation">
        <div class="col-9">
          <p class="font-bold font-5x mb-1">How would you like to proceed?</p>
        </div>

        <div class="col-3 text-right step--count">
          <p class="mb-0 font-bold">{{ 'Step '+currentStep+' of 3' }}</p>
        </div>

        <div class="col">
          <p>Select the correct option below and click on "Continue"</p>
        </div>
        <div class="col-12">
          <p class="mb-0">Field marked with an asterisk (<span class="mandatory">*</span>) is
            required.</p>
          <form [formGroup]="form">
            <div class="form-group">
              <label for="documentName" id="documentNameLabel" class="font-bold">Name <span
                  class="mandatory">*</span></label>
              <!-- UF-45813 onPaste event removed -->
              <input type="text" class="form-control font-bold" id="documentName" name="documentName"
                formControlName="taxonomyName" [(ngModel)]="documentName" (keyup)="onNameChange($event)" required>
              <p class="form-text text-muted text-right">Name it so your team can easily understand.</p>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="dropdown col-12">
                  <app-auto-complete [listingObj]="allNodeTemplateList" (selectedObject)="updateSelectedObject($event)"
                    [selectType]="selectType" [uniqueId]="uniqueId" [propName]="'name'" [isMandatory]="false"
                    [defaultSelection]="defalutNodeTemplate" [autoCompleteTitle]="autoCompleteTitle" #autoComplete>
                  </app-auto-complete>
                </div>

                <div class="col-12 pt-2 text-right">
                  <button class="text-underline btn btn-clear font-bold" data-toggle="modal"
                    data-target="#previewTemplate" id="previewTemplateBtn"
                    [hidden]="selectedNodeTemplate?.node_template?.trim() === ''">Preview
                    Template<span class="sr-only">Opens in a new dialog</span>
                  </button>
                </div>
              </div>
            </div>
          </form>

        </div>


      </section>
    </div>
  </div>

</ng-container>
<ng-container *ngIf="taxonomyData === undefined || taxonomyData=== null || savingData"
  class="d-flex col-12 p-0 uploader-loading">
  <app-preloader [loaderText]="'Loading data...'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
</ng-container>

<section *ngIf="taxonomyData && (currentStep === 3)" class="row justify-content-center mt-4">
  <ng-container>

    <section id="accordion" class="col-10 tree tree--builder px-0">
      <section>

        <ng-container
          *ngIf="dragDropData && dragDropData.length>0 && dragDropData[0].children && dragDropData[0].children.length > 0 && enableDND && !savingData">
          <div class="row justify-content-center">
            <div class="col-12" [ngStyle]="{'opacity':updateItem?0.3:1}">
              <app-tree-reorder #treeViewRef [dataList]="dragDropData[0].children"
                (treeUpdateEvent)="onTreeUpdate($event)" [viewType]="'reorder-taxonomy'"></app-tree-reorder>
            </div>

          </div>
        </ng-container>
        <app-tree #tree *ngIf="!enableDND && currentOption !== 'edit'" [treeNodes]="taxonomyData[0].children" [viewLocation]="'taxonomy_builder'"
          [showComplaince]="true" [level]="currentLevel" [levelLimit]="templateLevelLength"
          [selectedNodeId]="selectedNode.id" (addNodeEvent)="addNodeEvent($event)"
          (deleteNodeEvent)="deleteNodeEvent($event)" [isAllNode]="isAllNode" [isAddNode]="createNodePermission"
          [isDeleteNode]="deleteNodePermission" (human_coding_scheme)="setHumanCodingSchemeEvent($event);"
          (full_statement)="setFullStatementEvent($event);" (document_title)="setDocumentTitleEvent($event);"
          [full_statement_acknowledgement]="fullStatementAck"
          [nodetypeList]="nodetypeData" (metadataType)="setMetadataTypeEvent($event);"
          (nodeTypeIdEvent)="setNodeTypeIdEvent($event)" [flagResponse]="flagResponse">
        </app-tree>
        <app-edit-tree #appTree
           *ngIf="editTaxonomyData && currentOption === 'edit'"
          [documentId] = "document_id"
          [templateSelected] = "isTemplateSelected"
          [treeNodes]="editTaxonomyData" [viewLocation]="'taxonomy_builder'"
          [showComplaince]="true" [level]="currentLevel" [levelLimit]="templateLevelLength"
          [selectedNodeId]="selectedNode.item_id" (addNodeEvent)="addNodeEvent($event)"
          (deleteNodeEvent)="deleteNodeEvent($event)" [isAllNode]="isAllNode" [isAddNode]="createNodePermission"
          [isDeleteNode]="deleteNodePermission" (human_coding_scheme)="setHumanCodingSchemeEvent($event);"
          (full_statement)="setFullStatementEvent($event);" (document_title)="setDocumentTitleEvent($event);"
          [nodetypeList]="nodetypeData" (metadataType)="setMetadataTypeEvent($event);"
          (nodeTypeIdEvent)="setNodeTypeIdEvent($event)" [flagResponse]="flagResponse">
        </app-edit-tree>
      </section>
      <div *ngIf="!enableDND" class="form-text text-muted text-right">Statement is mandatory.</div>
    </section>

  </ng-container>

  <section class="col-sm-12 col-md-9 col-lg-7 push-top-5rem">
    <app-protip *ngIf="showProtipTaxonmyBuilder" [type]="type"></app-protip>
  </section>

</section>
